import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import { EMenuActions } from "../../store";
import ViewOrder from "./viewOrder";

const View = () => {
	let dispatch = useDispatch();

	const handleCloseReview = () => {
		dispatch(EMenuActions.setViewOrder(false));
	};

	return (
			<div>
				<div className="w-full py-3 items-center bg-secondary flex justify-between px-4">
					<div className="cursor-pointer">
					<motion.div
						whileHover={{ scale: 1.04 }}
						transition={{ duration: 0.3 }}
						className="w-[10%] cursor-pointer"
						onClick={handleCloseReview}
					>
							<FontAwesomeIcon icon={faArrowLeftLong} size="xl" className="text-black" />
						</motion.div>
					</div>
					<div className="m-auto">
						<h1 className="text-white font-bold flex justify-center">View Order</h1>
					</div>
				</div>
				<ViewOrder />
			</div>
	);
};
export default View;
